import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import bgr from './bgr.json';

export const languages = [
  { key: 'en', name: 'English', flag: 'uk' },
  { key: 'bgr', name: 'български', flag: 'bulgaria' }
];

i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, bgr: { translation: bgr } },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

const storedLanguage = localStorage.getItem('language');
if (languages.map(l => l.key).indexOf(storedLanguage) > -1) i18n.changeLanguage(storedLanguage);
i18n.on('languageChanged', lang => localStorage.setItem('language', lang));

export default i18n;
